import "./Modal.css";

export default function Modal({ title, children, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button onClick={onClose}>✖</button>
        </div>

        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}